import { LargeButton } from 'src/elements/Button'
import { Link } from 'src/elements/Link'
import {
  _contributiontext,
  _inversingbuttonshadow,
  _profilegreen,
  accentColor,
  accentLightColor,
  lightgray,
  orange,
  truewhite,
  white,
} from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import { inversing } from 'src/styles/mixins'
import styled, { css } from 'styled-components'

const ctaStyle = css`
  display: flex;
  justify-content: center;
  padding: 15px 5px;
  border-radius: 5px;
  border: 1px solid ${accentColor};
  box-shadow: ${_inversingbuttonshadow};
  font-size: 14px;
  font-weight: ${fontWeightBold};
  ${inversing({ color: _contributiontext, background: truewhite })};
`
const ButtonStyle = css`
  display: block;
  height: 48px;
  width: 100%;
  max-width: 280px;
  border-radius: 5px;
  border: 1px solid ${accentColor};
  background: ${accentLightColor};
  color: ${_contributiontext};
  font-size: 14px;
  text-align: center;
  line-height: 48px;
  font-weight: ${fontWeightBold};
  box-shadow: ${_inversingbuttonshadow};
  box-shadow: 3px 6px 10px rgba(226, 226, 226, 1);
  @media screen and (min-width: 540px) {
    font-size: 18px;
  }
`

const formButtonStyle = css`
  background-color: ${orange};
  color: ${white};
  margin: 0 auto;
  display: block;
`

export const EventItemButtonLink = styled(Link)`
  ${ctaStyle};
`

export const EventBottomButton = styled.button`
  ${ButtonStyle};
`

export const EventDetailButton = styled(LargeButton)`
  width: 204px;
  padding: 10px 0;
  margin: 0 auto;
  border: 1px solid ${_profilegreen};
  color: ${_profilegreen};
`

export const EventSubmitButton = styled(LargeButton)`
  ${formButtonStyle};
`

export const EventDisableButton = styled(LargeButton)`
  ${formButtonStyle};
  background-color: ${lightgray};
`

export const ModalCloseButton = styled(LargeButton)`
  ${formButtonStyle};
  background-color: ${lightgray};
`

export const GoogleFormLink = styled.a`
  border-radius: 5px;
  padding: 10px 81px;
  font-size: 14px;
  font-weight: ${fontWeightBold};
  height: 50px;
  text-align: center;
  white-space: nowrap;
  background-color: ${orange};
  color: ${white};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-decoration: none;
  cursor: pointer;
  margin: 0 auto;
  width: fit-content;

  svg {
    width: 20px;
    height: 20px;
  }
`

export const EventThumbnail = styled.div`
  width: 600px;
  height: 315px;
  border-radius: 10px;
  padding-top: 70.597%;
  position: relative;
  overflow: hidden;
  margin: 0 auto;

  img {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    object-fit: contain;
  }
`

export const EventThumbnailForIndex = styled.div`
  width: 100%;
  height: 0;
  border-radius: 16px 16px 0 0;
  padding-top: 70.597%;
  position: relative;
  overflow: hidden;
  margin: 0 auto;

  img {
    position: absolute;
    width: 100%;
    height: 100%;
    inset: 0;
    object-fit: contain;
  }
`
